// TODO: Move this to the upload model
export class SummaryPaneService {
  constructor(private $http) {
    'ngInject';
  }

  search(query) {
    // TODO: Move to api
    return this.$http.post('/aptitude/api/search', query);
  }
}
